import store from 'modules/base/store';

window.store = store.configure();
window.actionTypes = store.actionTypes;



// WEBPACK FOOTER //
// ./source/apps/base.js